import { useCallback, useEffect } from 'react'
import { viewport } from '@telegram-apps/sdk-react'
import { PropsWithChildren } from 'react'
import CoinAnimation from '@/ui/loader'
import AuthFallback from '@/ui/auth-fallback'
import '../i18n.js'
import { authPending, errorMessage, authData, retry, auth } from '@/shared/auth'

export default function AppInitProvider({ children }: PropsWithChildren) {
  const handleRetry = useCallback(async () => {
    retry()
  }, [])

  const setCssVariables = useCallback(() => {
    const safeAreaInsets = viewport.safeAreaInsets()
    const contentSafeAreaInsets = viewport.contentSafeAreaInsets()

    document.documentElement.style.setProperty(
      '--safe-area-inset-top',
      `${safeAreaInsets.top}px`,
    )
    document.documentElement.style.setProperty(
      '--safe-area-inset-right',
      `${safeAreaInsets.right}px`,
    )
    document.documentElement.style.setProperty(
      '--safe-area-inset-bottom',
      `${safeAreaInsets.bottom}px`,
    )
    document.documentElement.style.setProperty(
      '--safe-area-inset-left',
      `${safeAreaInsets.left}px`,
    )

    document.documentElement.style.setProperty(
      '--content-safe-area-inset-top',
      `${contentSafeAreaInsets.top}px`,
    )
    document.documentElement.style.setProperty(
      '--content-safe-area-inset-right',
      `${contentSafeAreaInsets.right}px`,
    )
    document.documentElement.style.setProperty(
      '--content-safe-area-inset-bottom',
      `${contentSafeAreaInsets.bottom}px`,
    )
    document.documentElement.style.setProperty(
      '--content-safe-area-inset-left',
      `${contentSafeAreaInsets.left}px`,
    )
  }, [])

  const initApp = useCallback(async () => {
    setCssVariables()

    auth()
  }, [setCssVariables])

  useEffect(() => {
    initApp()
  }, [initApp])

  if (errorMessage.value && !authPending.value) {
    return <AuthFallback onRetry={handleRetry} />
  }

  return <>{authData.value ? <>{children}</> : <CoinAnimation />}</>
}
